import {IAvailabilityCriteria} from 'Common/models/IAvailabilityCriteria';

export function isAvailableForBah(horseAccessCriteria: IAvailabilityCriteria): boolean {
  if (!horseAccessCriteria) {
    return false;
  }

  return Object.values(horseAccessCriteria).every((item) => item);
}
